import * as React from "react";
import * as moment from "moment";

var ReminderSection = function ReminderSection(props) {
  var expirationReminderSentAt = props.expirationReminderSentAt,
      polizaCode = props.polizaCode,
      finishDate = props.finishDate;

  if (!expirationReminderSentAt) {
    return null;
  }

  var formatDate = function formatDate(dateValue) {
    if (!dateValue) {
      return null;
    }

    var momentDate; // If it's already in DD-MM-YYYY format (from backend), parse it explicitly

    if (typeof dateValue === "string" && dateValue.match(/^\d{2}-\d{2}-\d{4}$/)) {
      momentDate = moment(dateValue, "DD-MM-YYYY", true);
    } else {
      // Try parsing as ISO date or other standard formats
      momentDate = moment(dateValue);
    }

    if (!momentDate.isValid()) {
      return null;
    }

    return momentDate.format("DD-MM-YYYY");
  };

  var formatDateTime = function formatDateTime(dateValue) {
    if (!dateValue) {
      return "";
    } // expiration_reminder_sent_at comes as ISO datetime, so parse normally


    var momentDate = moment(dateValue);

    if (!momentDate.isValid()) {
      return "";
    }

    return momentDate.format("DD-MM-YYYY HH:mm");
  };

  var formattedSentDate = formatDateTime(expirationReminderSentAt);
  var formattedExpirationDate = formatDate(finishDate);
  return /*#__PURE__*/React.createElement("div", {
    className: "reminder-section",
    style: {
      marginBottom: "20px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "10px 15px",
      backgroundColor: "#d4edda",
      borderColor: "#c3e6cb"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: "0",
      fontSize: "16px",
      color: "#155724"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-check-circle",
    style: {
      marginRight: "8px",
      color: "#28a745"
    }
  }), "Recordatorio de Vencimiento Enviado")), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "15px",
      backgroundColor: "#d4edda"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "13px",
      color: "#155724"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Fecha de env\xEDo:"), " ", formattedSentDate), polizaCode && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "P\xF3liza:"), " ", polizaCode), formattedExpirationDate && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "8px"
    }
  }, /*#__PURE__*/React.createElement("strong", null, "Fecha de vencimiento:"), " ", formattedExpirationDate), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "10px",
      paddingTop: "10px",
      borderTop: "1px solid #c3e6cb",
      fontSize: "12px",
      color: "#155724"
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-info-circle",
    style: {
      marginRight: "5px"
    }
  }), "El recordatorio de vencimiento fue enviado exitosamente al cliente.")))));
};

export default ReminderSection;